export default __webpack_public_path__ + "7c39855253dc5c16e0612a0781db7087.ogg";